/**
 * Notification rules loader reducer
 */

const load = function(state = {}, action) {
  switch (action.type) {
    case "LOAD_NOTIFICATIONS_RULES_START":
    case "LOAD_SINGLE_SITE_NOTIFICATIONS_RULES_START":
      return {
        ...state,
        loading: true
      };
    case "LOAD_NOTIFICATIONS_RULES_FAILED":
    case "LOAD_SINGLE_SITE_NOTIFICATIONS_RULES_FAILED":
      return {
        ...state,
        loading: false,
        error: action.error
      };
    case "LOAD_NOTIFICATIONS_RULES_SUCCESS":
    case "LOAD_SINGLE_SITE_NOTIFICATIONS_RULES_SUCCESS":
      return {
        ...state,
        loading: false,
        data: action.data.integrations
      };
    default:
      return state;
  }
}

export default load;